<template>
  <form
    class="dashed-outline"
    @dragover="dragOverHandler"
    @drop="dropHandler"
    v-bind:class="{ disableddrop: disabled }"
  >
    <v-container fluid style="height:100%">
      <v-row style="height:100%">
        <v-col cols="12" style="height:100%">
          <v-row align="center" justify="center" style="height:100%">
            <p class="title pa-0 ma-0 pb-1">
              Drag and Drop Excel / CSV Sheet
            </p>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </form>
</template>
<style scoped>
.disableddrop {
  border-color: #9d9e9e !important;
  background-color: #5c5c5c18 !important;
}
.disableddrop:hover {
  cursor: no-drop !important;
}
.dashed-outline {
  transition: background-color 0.5s ease;
  border-style: dashed !important;
  border-color: #24a3d1;
  background-color: #24a3d118;
  border-radius: 4px;
  margin-top: 3px;
  border-width: 2px;
  width: 99.8%;
  height: 192px;
}
.filter_menu {
  overflow-x: hidden;
  overflow-y: hidden;
}
.fake-hover:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
<script>
export default {
  props: ["value", "disabled"],
  methods: {
    simulateClick() {
      // this.$refs["file-input"].$el.click();
    },
    dragOverHandler(ev) {
      console.log("File(s) in drop zone");

      // Prevent default behavior (Prevent file from being opened)
      ev.preventDefault();
    },
    dropHandler(ev) {
      console.log("File(s) dropped");

      // Prevent default behavior (Prevent file from being opened)
      ev.preventDefault();
      if (this.disabled) {
        return;
      }
      if (ev.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        for (var i = 0; i < ev.dataTransfer.items.length; i++) {
          // If dropped items aren't files, reject them
          if (ev.dataTransfer.items[i].kind === "file") {
            var file = ev.dataTransfer.items[i].getAsFile();
            this.$emit("input", file);
            console.log("x", "... file[" + i + "].name = " + file.name);
          }
        }
      } else {
        // Use DataTransfer interface to access the file(s)
        // eslint-disable-next-line no-redeclare
        for (var i = 0; i < ev.dataTransfer.files.length; i++) {
          console.log(
            "y",
            "... file[" + i + "].name = " + ev.dataTransfer.files[i].name
          );
        }
      }
    }
  }
};
</script>

<style></style>
